import type { MessageType } from '@sydle/ui-api';
import type { CommandBody } from '../CrossOriginMessage';

export interface Message {
  code: string;
  text: string;
  type: MessageType;
  context: string;
}

/**
 * Add a alert message.
 */
export class AlertCommandBody implements CommandBody {
  /**
   * Type `add` indicates that the message will be added.
   */
  type: 'add';
  messages: Message[];
}
